<template>
  <div>
    <template>
      <div style="margin-bottom: 20px">
        <a-upload
          name="file"
          :multiple="true"
          :action="getUploadOssUrl"
					:data="{token: token}"
          @change="handleChange"
        >
          <a-button type="primary"> <a-icon type="upload" />上传文件</a-button>
        </a-upload>
      </div>
      <a-table :columns="columns" :pagination="pagination" :data-source="picList" @change="pageChange">
        <a slot="name" slot-scope="text">{{ text }}</a>
        <span slot="oss_url" slot-scope="oss_url">
          <img style="max-width: 60px; max-height: 60px" :src="oss_url" alt="" />
        </span>
        <span slot="specially_oss_url" slot-scope="specially_oss_url">
					<span>{{specially_oss_url}}</span>
          <span style="color: #1890ff; cursor: pointer" v-clipboard:copy="specially_oss_url"
      		v-clipboard:success="onCopy"
      		v-clipboard:error="onError"> 复制链接 </span>
        </span>
        <span slot="action" slot-scope="text, record">
						<a-popconfirm placement="right" ok-text="确认" cancel-text="取消" @confirm="remove(record)">
							<template slot="title">
								<p>确定删除该图片吗？删除后原有图片地址将失效！</p>
							</template>
							<a-button>删除</a-button>
						</a-popconfirm>	
        </span>
      </a-table>
    </template>
  </div>
</template>
<script>
import ClientManageVue from './ClientManage.vue';

const axios = require('axios')
const columns = [
  {
    title: "文件名称",
    dataIndex: "title",
    key: "title",
    slots: { title: "customTitle" },
    scopedSlots: { customRender: "title" },
  },
  {
    title: "预览",
    dataIndex: "oss_url",
    key: "oss_url",
    scopedSlots: { customRender: "oss_url" },
  },
  {
    title: "链接",
    dataIndex: "specially_oss_url",
    key: "specially_oss_url",
    scopedSlots: { customRender: "specially_oss_url" },
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

// const picList = [
//   {
//     id: 1,
//     key: "1",
//     name: "John Brown",
//     url: "http://ddywbdthumb.oss-cn-beijing.aliyuncs.com/WechatIMG2.jpeg",
//     address: "http://ddywbdthumb.oss-cn-beijing.aliyuncs.com/WechatIMG2.jpeg",
//   },
// ];
export default {
  name: "MaterialManage",
  data() {
    return {
      picList: [
				{
					client_id: '',
					oss_url: '',
					specially_oss_url: '',
					u_specially_oss_id: '',
					title: ''
				}
			],
      columns,
			token: sessionStorage.token,
			pagination: {
        // hideOnSinglePage: true,
        // showTotal: (total) => `共 ${total} 个机器人`,
				total: 50,
        pageSize: 15,
        current: 1,
			},
			page: 1
    };
  },
  computed: {
    getUploadOssUrl: function () {
      return global.DOMAIN + global.API_VERSION + "uupload/upload_oss"
    },
  },
	mounted(){
		this.getList(this.page)
	},
  methods: {
    handleChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} 上传成功！`);
				this.page = 1
				this.getList(this.page)
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 上传失败`);
      }
    },
		onCopy(){
			this.$message.success("内容已复制到剪切板！")
		},
		onError(){
			this.$message.error("抱歉，复制失败！")
		},
		getList(page){
			axios.post(global.DOMAIN + global.API_VERSION + 'uupload/get', {
        token: sessionStorage.token,
				page: page,
				pagesize: 15
      })
        .then((data) => {
          if (data.data.err_code === 0) {
						let val = data.data.content
						this.picList = val.source_urls
						this.pagination = {
							total: val.total_count,
							pageSize: val.pagesize,
							current: page,
						}
          } else if (data.data.err_code === 50002) {

          }
        })
		},
		remove(record){
			console.log(record);
			axios.post(global.DOMAIN + global.API_VERSION + 'uupload/delete_oss', {
        token: sessionStorage.token,
				u_specially_oss_id: record.u_specially_oss_id
      })
        .then((data) => {
          if (data.data.err_code === 0) {
						this.$message.success(`删除成功！`)
						this.getList(this.page)
          } else if (data.data.err_code === 50002) {

          }
        })

		},
		pageChange(e){
			this.pagination.current = e.current
			this.page = e.current
		this.getList(this.page)

		}
  },
};
</script>